(() => {
  const drawer = document.getElementById('bb-drawer');
  const drawerOverlay = document.getElementById('bb-overlay');
  const drawerClose = document.getElementById('bb-dx');
  const drawerOpeners = [
    document.getElementById('bb-ham'),
    document.getElementById('allbtn'),
  ].filter(Boolean);
  const emirateSheet = document.getElementById('bb-emirate-sheet');
  const emirateOverlay = document.getElementById('bb-emirate-overlay');
  const emirateClose = document.getElementById('bb-emirate-close');
  const emirateTriggers = [
    document.getElementById('bb-loc-trigger'),
    document.getElementById('bb-deliver-trigger'),
  ].filter(Boolean);
  let drawerOpener = null;
  let emirateOpener = null;

  const getFocusable = (container) =>
    Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => !element.hidden && element.getClientRects().length > 0);

  const setDrawerState = (open, restoreFocus = true) => {
    if (!drawer) return;
    drawer.classList.toggle('bb-open', open);
    drawerOverlay?.classList.toggle('bb-open', open);
    drawer.toggleAttribute('inert', !open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    drawerOpeners.forEach((button) => button.setAttribute('aria-expanded', open ? 'true' : 'false'));
    if (open) {
      requestAnimationFrame(() => drawerClose?.focus());
    } else if (restoreFocus && drawerOpener?.isConnected) {
      requestAnimationFrame(() => drawerOpener.focus());
    }
  };

  const setEmirateState = (open, restoreFocus = true) => {
    if (!emirateSheet) return;
    emirateSheet.classList.toggle('bb-open', open);
    emirateOverlay?.classList.toggle('bb-open', open);
    emirateSheet.toggleAttribute('inert', !open);
    emirateSheet.setAttribute('aria-hidden', open ? 'false' : 'true');
    emirateTriggers.forEach((button) => button.setAttribute('aria-expanded', open ? 'true' : 'false'));
    if (open) {
      requestAnimationFrame(() => {
        const selected = emirateSheet.querySelector('[role="radio"][aria-checked="true"]');
        (selected || emirateClose)?.focus();
      });
    } else if (restoreFocus && emirateOpener?.isConnected) {
      requestAnimationFrame(() => emirateOpener.focus());
    }
  };

  drawerOpeners.forEach((button) => {
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', () => {
      drawerOpener = button;
      setDrawerState(true, false);
    });
  });

  drawerClose?.addEventListener('click', () => setDrawerState(false));
  drawerOverlay?.addEventListener('click', () => setDrawerState(false));

  emirateTriggers.forEach((button) => {
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', () => {
      emirateOpener = button;
      setEmirateState(true, false);
    });
  });

  emirateClose?.addEventListener('click', () => setEmirateState(false));
  emirateOverlay?.addEventListener('click', () => setEmirateState(false));
  emirateSheet?.querySelectorAll('.bb-emirate-opt').forEach((option) => {
    option.addEventListener('click', () => setEmirateState(false));
  });

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Escape') {
        if (drawer?.classList.contains('bb-open')) {
          event.preventDefault();
          setDrawerState(false);
          return;
        }
        if (emirateSheet?.classList.contains('bb-open')) {
          event.preventDefault();
          setEmirateState(false);
        }
        return;
      }

      if (event.key !== 'Tab') return;
      const activeDialog = drawer?.classList.contains('bb-open')
        ? drawer
        : emirateSheet?.classList.contains('bb-open')
          ? emirateSheet
          : null;
      if (!activeDialog) return;
      const focusable = getFocusable(activeDialog);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },
    true
  );

  setDrawerState(false, false);
  setEmirateState(false, false);
})();
